const orderStatusIndex = {
	'-1': { color: 'canceled', status: 'canceled', text: 'İptal Edildi' },
	'1': { color: 'warning', status: 'open', text: 'Açık' },
	'2': { color: 'open', status: 'open', text: 'Açık' },
	'3': { color: 'open', status: 'open', text: 'Açık' },
	'4': { color: 'ongoing', status: 'ongoing', text: 'Ödeme Yapılıyor' },
	'5': { color: 'success', status: 'success', text: 'Tamamlandı' },
	'6': { color: 'open', status: 'open', text: 'Açık' },
}

export default orderStatusIndex